import React, { useState } from "react";
import Button from "../modules/Button";
import edit from "../../Assets/svg/edit-icon.svg";
import StaticItem from "../modules/StaticItem";
import photo from "../../Assets/svg/photo.svg";
import { useSelector } from "react-redux";
function AddressColumn() {
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const [address, setAddress] = useState({
    addr1: "33B, Midtown Apartments",
    addr2: "20 Free School Street",
    city: "Kolkata",
    state: "West Bengal",
    pin: "700029",
  });
  const btnText = () => {
    return (
      <div className="btn-text">
        <span>Personal Details</span>
        <img src={edit} alt="download" />
      </div>
    );
  };
  const ageText = () => {
    return (
      <div className="age-text">
        <span className="year">29/10/1999</span>
        <span className="age">(24 Years)</span>
      </div>
    );
  };
  return (
    <div className="address-col ">
      {/* <div className="btn-div"> */}
      {/* </div> */}
      <div className="col">
        <div className="left-col">
          <div className="set-title">Current Address</div>
          <div className="instructions">
            This will be used for correspondence and verification
          </div>
          <div className="address">
            <div className="address-item">
              {
                personalInfo.address.filter(
                  (item) => item.addressType === "TEMPORARY"
                )[0]?.address1
              }
            </div>
            <div className="address-item">
              {
                personalInfo.address.filter(
                  (item) => item.addressType === "TEMPORARY"
                )[0]?.address2
              }
            </div>
            <div className="address-item">
              {
                personalInfo.address.filter(
                  (item) => item.addressType === "TEMPORARY"
                )[0]?.city
              }
            </div>
            <div className="address-item">
              {
                personalInfo.address.filter(
                  (item) => item.addressType === "TEMPORARY"
                )[0]?.state
              }
            </div>
            <div className="address-item">
              {
                personalInfo.address.filter(
                  (item) => item.addressType === "TEMPORARY"
                )[0]?.pin
              }
            </div>
            {personalInfo.address.filter(
              (item) => item.addressType === "TEMPORARY"
            )[0]?.pin !== "" &&
              personalInfo.address.filter(
                (item) => item.addressType === "TEMPORARY"
              )[0]?.pin !==
                personalInfo.address.filter(
                  (item) => item.addressType === "PERMANENT"
                )[0].pin && (
                <div className="doc-col">
                  {/* {tokenData.docs?.currentAddressProof && ( */}
                  <div className="doc-item">
                    <StaticItem
                      onChange={() => {}}
                      type={"doc"}
                      title={"Current Address Proof"}
                      doc={tokenData.docs?.currentAddressProof}
                      docUrl={tokenData.docs?.currentAddressProof?.documentUrl}
                      value={tokenData.docs?.currentAddressProof?.name}
                      size={Math.floor(
                        tokenData.docs?.currentAddressProof?.size / 1024
                      )}
                    />
                  </div>
                  {/* // )} */}
                </div>
              )}
          </div>
        </div>
        <div className="left-col">
          <div className="set-title">Permanent Address</div>
          <div className="instructions">
            This is where your family/guardian currently resides
          </div>
          <div className="address">
            <div className="address-item">
              <div className="address-item">
                {
                  personalInfo.address.filter(
                    (item) => item.addressType === "PERMANENT"
                  )[0].address1
                }
              </div>
              <div className="address-item">
                {
                  personalInfo.address.filter(
                    (item) => item.addressType === "PERMANENT"
                  )[0].address2
                }
              </div>
              <div className="address-item">
                {
                  personalInfo.address.filter(
                    (item) => item.addressType === "PERMANENT"
                  )[0].city
                }
              </div>
              <div className="address-item">
                {
                  personalInfo.address.filter(
                    (item) => item.addressType === "PERMANENT"
                  )[0].state
                }
              </div>
              <div className="address-item">
                {
                  personalInfo.address.filter(
                    (item) => item.addressType === "PERMANENT"
                  )[0].pin
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddressColumn;
